import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { NavigatorButton as NavigatorButtonMemoized } from './components/NavigatorButton.js';
import { NavigatorLayoutV3 as NavigatorLayoutV3Memoized } from './components/NavigatorLayoutV3.js';

/**
 * INTERNAL component for navigating in an overflowing container.
 */
var NavigatorV3 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(NavigatorLayoutV3Memoized, props, /*#__PURE__*/React.createElement(NavigatorButtonMemoized, _extends({}, props, {
    ref: ref
  })));
});
var NavigatorV3Memoized = /*#__PURE__*/React.memo(NavigatorV3);
NavigatorV3Memoized.displayName = 'NavigatorV3';

export { NavigatorV3Memoized as NavigatorV3 };
//# sourceMappingURL=NavigatorV3.js.map
